/**
 * @param {string} target 대상이 될 문자열
 * @param {number} length 마스킹 된 후 문자열의 총 길이
 * @example maskingString("MASKING",3) => "M**"
 */
const maskingString = (target: string | null | undefined, length = 4) => {
  switch (true) {
    case typeof target === 'undefined': {
      return '';
    }

    case target === null: {
      return '';
    }

    case target?.length === 0: {
      return '';
    }

    default: {
      return target?.substring(0, 1).padEnd(length, '*') as string;
    }
  }
};

export default maskingString;

/**
 * @param {string} bankAccountNumber 은행 계좌 번호
 * @example maskingString("110411708804") => "110****8804"
 * 길이에 상관없이 앞 3, 뒤 4자리 제외하고 중간 문자열 전부 * 4자리 치환
 */
const REPLACEMENT_STARS = '****';

export const maskingBankAccount = (bankAccountNumber?: string | null) => {
  if (!bankAccountNumber) return '';

  const startNumbers = bankAccountNumber.slice(0, 3);
  const endNumbers = bankAccountNumber.slice(-4);
  return startNumbers + REPLACEMENT_STARS + endNumbers;
};
